import { Component, OnInit } from '@angular/core';
import { UserService, TrabajosInvitadosService, CongresosService } from '../../services/services.index';
import { Congreso } from '../../models/congreso.model';

@Component({
  selector: 'app-trabajos-invitados-lista',
  templateUrl: './trabajos-invitados-lista.component.html',
  styles: []
})
export class TrabajosInvitadosListaComponent implements OnInit {

  trabajos: any;
  simposios: any[];
  hideModalTrabajoInvitado: string = 'hide-modal';
  trabajoInvitado: any;
  loading: boolean = true;
  congreso: Congreso;
  certificadosHabilitados: boolean = false;

  constructor(public _userService: UserService,
              public _trabajosInvitadosService: TrabajosInvitadosService,
              public _congresosService: CongresosService) { }

  ngOnInit() {
    this.loading = false;
    if (this._userService.user.estadoTrabajoInvitado === 'aprobado') {
      this.loading = true;
      this._trabajosInvitadosService.getTrabajosInvitado(this._userService.user).subscribe(respTrabajosInvitado => {
        this.loading = false;
        this.trabajos = respTrabajosInvitado;
      });
    }
    this.cargarCongreso();
  }

  cargarCongreso() {
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today > this.congreso.fechaFinCongreso) {
          this.certificadosHabilitados = true;
        } else {
          this.certificadosHabilitados = false;
        }
      }
    });
  }

  hideModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = 'hide-modal';
  }

  showModalRevisionTrabajoInvitado() {
    this.hideModalTrabajoInvitado = '';
  }

  verTrabajoInvitado(trabajo: any) {
    this.showModalRevisionTrabajoInvitado();
    this.trabajoInvitado = trabajo;
  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1) + '.';
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    for (let lugar of lugaresTrabajo) {
      if (superindice === '') {
        superindice = superindice + lugar;
      } else {
        superindice = superindice + ',' + lugar;
      }
    }
    return superindice;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trabajos-invitados-lista/trabajos-invitados-lista.component.ts